export type AdminLang = "ru" | "en" | "az";

export const ADMIN_LOCALE_STORAGE_KEY = "uqx-admin.locale";

export const ADMIN_LANGS: AdminLang[] = ["az", "ru", "en"];

export const ADMIN_LANG_NAMES: Record<AdminLang, string> = {
  az: "Azərbaycan",
  ru: "Русский",
  en: "English",
};

export const resourceLabels: Record<AdminLang, Record<string, string>> = {
  ru: {
    phphrase: "Мотивационные фразы",
    phmusic: "Музыка",
    phemotions: "Записи эмоций",
    phintro: "Intro-видео",
    phbreathing: "Дыхательные упражнения",
    phemotiontype: "Типы эмоций",
    phhomesection: "Секции главной",
    phhelper: "Digər köməkçilər / Daha çox",
    phnews: "Новости",
    phblog: "Блог",
    phabout: "Haqqımızda",
    phvideo: "Media",
    phgame: "Игры",
    phcatalog: "Tibbi mənbə",
    phappconfig: "Параметры приложения",
  },
  en: {
    phphrase: "Motivational phrases",
    phmusic: "Music",
    phemotions: "Emotion records",
    phintro: "Intro video",
    phbreathing: "Breathing exercises",
    phemotiontype: "Emotion types",
    phhomesection: "Home sections",
    phhelper: "Helpers / More",
    phnews: "News",
    phblog: "Blog",
    phabout: "About us",
    phvideo: "Media",
    phgame: "Games",
    phcatalog: "Medical guide",
    phappconfig: "App settings",
  },
  az: {
    phphrase: "Motivasiya ifadələri",
    phmusic: "Musiqi",
    phemotions: "Emosiya qeydləri",
    phintro: "Intro video",
    phbreathing: "Nəfəs məşqləri",
    phemotiontype: "Emosiya növləri",
    phhomesection: "Əsas səhifə bölmələri",
    phhelper: "Digər köməkçilər / Daha çox",
    phnews: "Xəbərlər",
    phblog: "Bloq",
    phabout: "Haqqımızda",
    phvideo: "Media",
    phgame: "Oyunlar",
    phcatalog: "Tibbi mənbə",
    phappconfig: "App parametrləri",
  },
};

export const buildResources = (lang: AdminLang) => {
  const labels = resourceLabels[lang];
  return Object.fromEntries(
    Object.entries(labels).map(([name, label]) => [name, { name: label }]),
  );
};
